import { c as _c } from "react/compiler-runtime";
import { Slot } from "@radix-ui/react-slot";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
export function YNSButton(t0) {
  const $ = _c(26);
  let className;
  let props;
  let size;
  let t1;
  let theme;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      size,
      asChild: t1,
      theme,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
    $[4] = t1;
    $[5] = theme;
    $[6] = variant;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
    t1 = $[4];
    theme = $[5];
    variant = $[6];
  }
  const asChild = t1 === undefined ? false : t1;
  const Comp = asChild ? Slot : "button";
  let T0;
  let style;
  let t2;
  let t3;
  if ($[7] !== Comp || $[8] !== className || $[9] !== props || $[10] !== size || $[11] !== theme || $[12] !== variant) {
    const baseClasses = buttonVariants({
      variant,
      size
    }).split(/\s/g).filter(_temp).join(" ");
    const themeClasses = cn("yns-global-button", "font-semibold", "transition-colors", "focus:outline-hidden focus:ring-1 focus:ring-current", "bg-[var(--yns-button-bg,inherit)]", "text-[var(--yns-button-color,inherit)]", "hover:bg-[var(--yns-button-hover-bg,inherit)]", "border-[color:var(--yns-button-border-color,inherit)]", "[:where(&)]:shadow-xs", theme?.radius === "none" && "rounded-none", theme?.radius === "sm" && "rounded-sm", theme?.radius === "md" && "rounded-md", theme?.radius === "lg" && "rounded-lg", theme?.radius === "full" && "rounded-full", theme?.border === "none" && "border-none", theme?.border === "sm" && "border-1", theme?.border === "md" && "border-2", theme?.border === "lg" && "border-4");
    let t4;
    if ($[17] !== props || $[18] !== theme) {
      t4 = theme ? {
        "--yns-button-bg": theme.backgroundColor || undefined,
        "--yns-button-color": theme.textColor || undefined,
        "--yns-button-hover-bg": theme.hoverBackgroundColor || undefined,
        "--yns-button-border-color": theme.borderColor || undefined,
        ...(props.style || {})
      } : props.style;
      $[17] = props;
      $[18] = theme;
      $[19] = t4;
    } else {
      t4 = $[19];
    }
    style = t4;
    T0 = Comp;
    t2 = "button";
    t3 = cn(baseClasses, themeClasses, className);
    $[7] = Comp;
    $[8] = className;
    $[9] = props;
    $[10] = size;
    $[11] = theme;
    $[12] = variant;
    $[13] = T0;
    $[14] = style;
    $[15] = t2;
    $[16] = t3;
  } else {
    T0 = $[13];
    style = $[14];
    t2 = $[15];
    t3 = $[16];
  }
  let t4;
  if ($[20] !== T0 || $[21] !== props || $[22] !== style || $[23] !== t2 || $[24] !== t3) {
    t4 = <T0 data-slot={t2} className={t3} style={style} {...props} />;
    $[20] = T0;
    $[21] = props;
    $[22] = style;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  return t4;
}
function _temp(cls) {
  return !cls.startsWith("shadow-");
}